<template>
<section class="hero is-fullheight">
  <!-- Hero content: will be in the middle -->
  <div class="hero-body">
    <div class="container">
      <div class="columns">
        <div class="column is-4 centerDiv">
            <div class="media logo">
                <div class="media-left">
                    <figure class="image">
                        <img class="logo" src="../assets/_logo.png" alt="Image" width="200">
                    </figure>
                </div>
            </div>      
            <div class="card">
                <div class="card-content">
                    <div :class="messageClass">
                        {{message}}
                    </div>
                    <form v-on:submit.prevent="onLogin" autocomplete="on">
                        <div class="field">
                            <label class="label">Username</label>
                            <p class="control">
                                <input class="input" type="text" placeholder="admin" v-model="username">
                            </p>
                        </div>
                        <div class="field">
                            <label class="label">Password</label>
                            <p class="control">
                                <input class="input" type="password" v-model="password">
                            </p>
                        </div>
                        <div class="field is-grouped">
                            <p class="control">
                                <button :class="submitClass">Log in</button>
                            </p>
                        </div>         
                    </form>
                </div>   
                <footer class="card-footer">
                    <a class="card-footer-item" href="https://biya.com.ng/" target="_blank"><i class="fa fa-lock"></i>&nbsp; Biya</a>
                </footer>        
            </div>
        </div>
      </div>
    </div>
  </div>
</section>
</template>

<script>
import axios from 'axios';
import url from '../utils/url';
export default {
  name: 'login',
  data() {
    return {
      username: '',
      password: '',
      messageClass: 'is-hidden',
      message: '',
      submitClass: 'button is-success is-fullwidth btn-mydefault'
    };
  },
  methods: {
    onLogin: function() {
      let self = this;
      self.submitClass = 'button is-success is-loading';
      axios({
        url: `/support/login`,
        baseURL: url,
        method: 'post',
        data: {
          username: self.username,
          password: self.password
        }
      })
        .then(function(result) {
          self.submitClass = 'button is-success';
          const token = result.data.token;
          window.localStorage.setItem('biyadmin', token);
          self.$router.push({ path: '/status' });
        })
        .catch(function(error) {
          const message = error.message ? error.message : 'There was an error';
          self.message = message;
          self.messageClass = 'notification is-danger';
          self.submitClass = 'button is-success';
        });
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.is-hidden {
  display: none;
}
.logo {
  max-width: 160px;
}
.centerDiv {
  margin-left: auto;
  margin-right: auto;
}
.hero {
  background: #021f0e; /* fallback for old browsers */
}

.card {
  border-radius: 8px;
  box-shadow: 0 1.5px 3px 0 rgba(55, 44, 55, 0.9);
  transition: 0.3s;
}

.card:hover {
  box-shadow: 0 1.5px 1px 0 rgba(0, 0, 0, 0.2);
  transition: 0.3s;
}

.logo {
  margin-left: auto !important;
  margin-right: auto !important;
}

.btn-mydefault {
  font-size: 16px;
  background: #0ac97b;
  border-color: #fff;
  color: #fff;
  transition: 1s;
}

.btn-mydefault:hover {
  background: #00c853;
}
footer > a {
  color: #000;
}

footer > a:hover {
  color: grey;
}

.notification {
  transition: 0.3s;
}
</style>



// WEBPACK FOOTER //
// Login.vue?cffb0bea